import Purchase from "../../UnderPrivete/Purchase";

export const closeRoutes = [
  { path: "/purchase/:purchaseId", Component: Purchase },
];
